export default function DocumentDetails() {
  return (
    <section className="sales-layout__page">
      <h1>Belegdetails</h1>
      <p>Die Belegdetails sind in Vorbereitung.</p>
    </section>
  );
}
